

import wx from '../../../static/images/wx.jpg';
import {urlConfig} from '@/api/urlConfig';
import {SFZValid} from '@/api/validate';
import {promptMessage,fetch} from '@/api/dataHandling';
import {getken} from '@/api/getToken';
import Vue from 'vue';
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import Countdown from 'vux/src/components/countdown/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Icon from 'vux/src/components/icon/index.vue'

Vue.use(ToastPlugin);
export default {
data(){
return {
headerTxt:'',
countdownstart:false,
messagedisabled:true,
numshow:false,
time: 0,
zhazhaoshow:false,
wx,
sexTxt:'',
basemessage:{
name:'',
sex:'',
tel:'',
yjDySj:'',
createPerson:'',
yanzheng:'',
sfzh:'',
},
toastTxt:'',
nameIcon:false,
telIcon:false,
sexIcon:false,
sfzhIcon:false,
yanzhengIcon:false,
yjDySjIcon:false,
toastShow:false,
submitdisabled:false,
sexoptions:[
{
value:'女',
key:'2'
},
{
value:'男',
key:'1'
}
],
timeoptions:[
{
value:'11月',
key:'2019-11'
},
{
value:'12月',
key:'2019-12'
},
]
}
},
methods: {
sfzhblur(){

this.basemessage.sfzh = this.basemessage.sfzh.trim();
if(this.basemessage.sfzh){
this.basemessage.sfzh = this.basemessage.sfzh.toUpperCase();
SFZValid(this.basemessage.sfzh);
if(SFZValid(this.basemessage.sfzh)){  // 通过验证
let SFZSex = (this.basemessage.sfzh.trim()).substring(this.basemessage.sfzh.length-2,this.basemessage.sfzh.length-1);
if(SFZSex%2 == 0) {  //女
this.basemessage.sex = '2';
this.sexTxt = '女'
}else{  //男
this.basemessage.sex = '1';
this.sexTxt = '男'
}
this.sfzhIcon = false;
}else{
this.sfzhIcon = true;
}
}else{
this.sfzhIcon = true;
this.$vux.toast.text('请输入身份证号');
}
},
messageBtn(){
if(this.basemessage.tel.trim() && !this.telIcon){

let _this = this;
setTimeout(function(){
_this.messagedisabled = true;
},1)

this.time = 60;
this.numshow = true;
this.countdownstart = true;
fetch('post',urlConfig.getValidateCode+'?ivfRegistrationHId='+this.$route.query.registratioHId+'&tel='+ this.basemessage.tel.trim()).then(response => {

}).catch(error => {
this.messagedisabled = false;
this.numshow = false;
this.countdownstart = false;
promptMessage('提示','获取验证码失败，请重新获取！')
})
}else {
promptMessage('提示','请输入正确的手机号码！')
}
}, //发送验证码
countdownfinish (index) {
this.numshow = false;
this.countdownstart = false;

if(this.basemessage.tel.trim() && !this.telIcon){
this.messagedisabled = false;
}else{
this.messagedisabled = true;
}
},
times(){
fetch('post',urlConfig.nationdayTimes+'?ivfRegistrationHId='+this.$route.query.registratioHId+'&registrationTgr='+ this.basemessage.createPerson).then(response => {
}).catch(error => {
})
},
iftrim () {
this.requiredMethod(
[this.basemessage.name, 'nameIcon'],
[this.basemessage.sex, 'sexIcon'],
[this.basemessage.tel, 'telIcon'],
[this.basemessage.yjDySj, 'yjDySjIcon'],
[this.basemessage.yanzheng, 'yanzhengIcon'],
[this.basemessage.sfzh, 'sfzhIcon'],
);
this.$nextTick(function () {
this.telchange();
})

}, // 判断是否为空
requiredMethod(){

for(let i=0;i<arguments.length;i++){
console.log(arguments[i][0],6,arguments[i],i,)
if(arguments[i][0].trim() == ''){
this[arguments[i][1]]= true;
}else{
this[arguments[i][1]]= false;
}
}

}, //是否必填
telchange(){

let patrn= /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;

this.$nextTick(function(){
this.basemessage.tel = this.basemessage.tel.trim().replace(patrn, "")
if(/^1[3456789]\d{9}$/.test(this.basemessage.tel)){
this.telIcon = false;
}else{
this.telIcon = true;
if(this.basemessage.tel){
this.$vux.toast.text('电话号码格式不正确，请核实！');
}
}
if(this.basemessage.tel.trim() && !this.telIcon){
if(!this.numshow){
this.messagedisabled = false;
}
}else {
this.messagedisabled = true;
}
})

},
IconClick(text){
this.$vux.toast.text(text);
},
submit(){
this.iftrim();
for(let i in this.basemessage){
this.basemessage[i] = this.basemessage[i].trim();
}
if(this.basemessage.name !="" && this.basemessage.sex !="" && this.basemessage.tel !="" && this.basemessage.yjDySj !="" && !this.nameIcon && !this.telIcon && !this.sexIcon  && !this.yjDySjIcon){
if(this.basemessage.yanzheng !=""){  // 验证码不为空
this.submitdisabled = true;
fetch('post',urlConfig.nationdaySave+'?ivfRegistrationHId='+this.$route.query.registratioHId+'&name='+this.basemessage.name+'&sex='+this.basemessage.sex +'&sfzh='+this.basemessage.sfzh+'&tel='+this.basemessage.tel + '&yjDySj=' +this.basemessage.yjDySj+ '&createPerson=' +this.basemessage.createPerson + '&validateCode='+this.basemessage.yanzheng).then(response => {

this.zhazhaoshow = true;

}).catch(error => {
this.submitdisabled = false;
this.$store.commit('updateLoadingStatus',{isLoading:false});
})
}else{
promptMessage('提示','请输入验证码！')
}

}else{
promptMessage('提示','请完善信息！')
}
},
},
components: {
Countdown,Toast,XDialog,XInput,Cell, Group, XHeader,XButton,Checker, CheckerItem,Icon
},
mounted(){

this.headerTxt = decodeURI(this.$route.query.registratioHName);
this.basemessage.createPerson = this.$route.query.registerId;
getken(this.times);

this.$nextTick(function(){
$('.inputClick').on('click',function(){
$(this).find('input').focus();
})
})
}
}



// WEBPACK FOOTER //
// ./src/project/activitiesProject/nationalDay.vue